@if (view == 'slider') {
  <app-files-slider
    [filesList]="files"
    [fileNameProperty]="fileNameProperty"
    [userId]="_gS.user.id"
    [editable]="_gS.validateAcces({id:31, type:'write'}) || _gS.validateAcces({id:19, type:'write'})"
    [position]="currentSlideIndex"
    (closeView)="onCloseSlider();"
    (onChangeSlide)="changeSlide($event)"
    (notify)="sliderResponse($event)">
  </app-files-slider>
}

@if (loading) {
  <div class="loader"></div>
}

<div class="file-viewer wrapper">
  <owl-carousel-o [options]="customOptions" #owlCar (initialized)="onInitializedCarousel($event)" (translated)="onChangedCarousel($event)">
    @for (file of files; track file; let i = $index) {
      <ng-template carouselSlide [id]="i">
        <div class="document-wrapper pointer">
          @if (_gS.getFileType(file.fileExtension) == 'pdf') {
            <div id="adobe-dc-view-{{file.id}}" ></div>
            <p class="fullscreen-btn" (click)="setView('slider')">&nbsp;</p>
          }
          @if (_gS.getFileType(file.fileExtension) == 'excel') {
            <div class="fullscreen-background" (click)="setView('slider')">
              <a (click)="$event.stopPropagation()"
                class="button button-download" [href]="file[fileUrlProperty]" target="_blank">
                {{'Download' | translate}}
                {{file[fileNameProperty].length > 30 ? (file[fileNameProperty]| slice: 0: 30) + '...' : file[fileNameProperty]}}
              </a>
            </div>
          }
          @if (_gS.getFileType(file.fileExtension) == 'image') {
            <div class="image-container" (click)="setView('slider')">
              <img class="image" [src]="file[fileUrlProperty]" imageLoader alt="" (load)="_gS.loadImage()">
            </div>
          }
          @if (loadingImage[i] && _gS.getFileType(file.fileExtension) == 'image') {
            <div class="loader image-loader"></div>
          }
        </div>
      </ng-template>
    }
  </owl-carousel-o>
</div>